import { render, staticRenderFns } from "./EmailPage.vue?vue&type=template&id=699c3002&scoped=true"
import script from "./EmailPage.vue?vue&type=script&lang=js"
export * from "./EmailPage.vue?vue&type=script&lang=js"
import style0 from "./EmailPage.vue?vue&type=style&index=0&id=699c3002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c3002",
  null
  
)

export default component.exports